export const USER_NOT_LOGGED_IN = 'USER_NOT_LOGGED_IN'; // server could not complete request as user is not logged in
export const EMBEDDED_USER_NOT_LOGGED_IN = 'EMBEDDED_USER_NOT_LOGGED_IN'; // server could not complete request as user is not logged in

export const LOADING = 'LOADING';
export const FAILED = 'FAILED';
export const EXCEPTION = 'EXCEPTION';
export const FINISHED = 'FINISHED';

// loading data
export const TABLES_LOADED = 'TABLES_LOADED'; // data loaded from server for populating tables in left sidebar
export const USER_ACTIONS_LOADED = 'USER_ACTIONS_LOADED'; // user actions for onboarding
export const USER_ACTION_FIRED = 'USER_ACTION_FIRED'; // user action has been fired
export const CHANGE_DATASOURCE = 'CHANGE_DATASOURCE'; // user action has been fired
export const RESET_DATASOURCE = 'RESET_DATASOURCE';
export const DATASOURCE_SELECTED = 'DATASOURCE_SELECTED'; // user action has been fired
export const SAVED_QUERY_SELECTED = 'SAVED_QUERY_SELECTED';
export const SAVED_QUERY_UPDATED = 'SAVED_QUERY_UPDATED';

export const TABLE_SELECTED = 'TABLE_SELECTED'; // user has clicked an initial table
export const VIEW_LOADED = 'VIEW_LOADED'; // data loaded from server for populating views in left sidebar
export const SEARCH_LOADED = 'SEARCH_LOADED'; // layers loaded for executing search query
export const MODAL_DATA_LOADED = 'MODAL_DATA_LOADED'; // server returned column data needed for loading modal
export const TABLE_ROWS_LOADED = 'TABLE_ROWS_LOADED'; // server returned row data for selected table
export const TABLE_FULL_ROWS_LOADED = 'TABLE_FULL_ROWS_LOADED'; // server returned all row data for selected table (with same headings)
export const MODAL_ROWS_LOADED = 'MODAL_ROWS_LOADED'; // row data for a modal
export const ROW_COUNT_LOADED = 'ROW_COUNT_LOADED'; // total row count for datatable loaded
export const COLUMNS_FOR_DATA_TABLE = 'COLUMNS_FOR_DATA_TABLE'; // columns for datatable (until results come back)
export const SHARED_ROWS_REQUEST_LOADED = 'SHARED_ROWS_REQUEST_LOADED'; // shared row request loaded
export const SUGGESTIONS_LOADED = 'SUGGESTIONS_LOADED'; // search suggestions loaded
export const SUGGESTIONS_CLICKED = 'SUGGESTIONS_CLICKED'; // search suggestions seen
export const SET_LOADING_TIMER = 'SET_LOADING_TIMER'; // sets the final count for the current timer
export const SCHEMA_LOADED = 'SCHEMA_LOADED'; // schema data for datasource loaded
export const SCHEMA_SAVED = 'SCHEMA_SAVED'; // schema data for datasource saved
export const CHANGE_TAB = 'CHANGE_TAB'; // user changed selected tab
export const REFRESH_RESULTS_CLICKED = 'REFRESH_RESULTS_CLICKED'; // user wants to refresh results
export const CSV_UPLOADED = 'CSV_UPLOADED'; // user uploading CSV
export const FEEDS_ON_OFF = 'FEEDS_ON_OFF'; // user turning feeds on/off
export const ALERTS_ON_OFF = 'ALERTS_ON_OFF'; // user turning slack and email alerts on/off
export const SHEETS_OTHER_TOOLS_ON_OFF = 'SHEETS_OTHER_TOOLS_ON_OFF'; // user turning sheets / other tools feeds on/off
export const REFRESH_DASHBOARDS_5_MIN_ON_OFF =
  'REFRESH_DASHBOARDS_5_MIN_ON_OFF'; // user enables/disables dashboards can be refreshed every 5 minutes
export const NEW_WORLD_TOGGLE = 'NEW_WORLD_TOGGLE'; // user switching between new and old world
export const TEMPLATE_LAYER_ADDED = 'TEMPLATE_LAYER_ADDED'; // user added template layer to query
export const INLINE_LAYER_ADDED = 'INLINE_LAYER_ADDED'; // user added layer directly inline (not via modal)
export const SUGGESTION_APPLIED = 'SUGGESTION_APPLIED';
export const SUGGESTIONS_CHANGED = 'SUGGESTIONS_CHANGED';

export const RESET_STEPS_STATE = 'RESET_STEPS_STATE';
export const START_NEW_QUERY = 'START_NEW_QUERY'; // user wants to start a new query
export const START_EDITING_LAYER_INLINE = 'START_EDITING_LAYER_INLINE'; // user wants to edit layer inline
export const SHARE_METADATA_LOADED = 'SHARE_METADATA_LOADED'; // metadata for a public dataset query
export const SHARE_METADATA_CHANGED = 'SHARE_METADATA_CHANGED'; // metadata for a public dataset query

// dashboards
export const DASHBOARDS_LOADED = 'DASHBOARDS_LOADED'; // list of dashboards loaded
export const DASHBOARD_CREATED = 'DASHBOARD_CREATED'; // a new dashboard has been created
export const REMOVE_PREVIEW_WIDGET = 'REMOVE_PREVIEW_WIDGET'; // a new dashboard has been created
export const DASHBOARD_DELETED = 'DASHBOARD_DELETED'; // dashboard has been deleted
export const DASHBOARD_UPDATED = 'DASHBOARD_UPDATED'; // changes to dashboard have been saved
export const DASHBOARD_LOADED = 'DASHBOARD_LOADED'; // dashboard widgets loaded
export const DASHBOARD_REFRESHED = 'DASHBOARD_REFRESHED'; // dashboard refresh started
export const DASHBOARD_CONTENT_LOADED = 'DASHBOARD_CONTENT_LOADED'; // dashboard data loaded
export const WIDGET_ADDED = 'WIDGET_ADDED'; // widget added to dashboard
export const DASHBOARD_FILTERS_LOADED = 'DASHBOARD_FILTERS_LOADED'; // loaded list of dashboard filters
export const PIN_REFRESHED = 'PIN_REFRESHED';
export const WIDGET_CONFIGURATION_UPDATED = 'WIDGET_CONFIGURATION_UPDATED';

export const SELECT_SAVED_QUERY_FOR_WIDGET = 'SELECT_SAVED_QUERY_FOR_WIDGET';

export const WIDGET_FILTERS_UPDATED = 'WIDGET_FILTERS_UPDATED';

// alerts
export const ALERTS_LOADED = 'ALERTS_LOADED'; // alerts loaded
export const ALERT_TAB_SWITCHED = 'ALERT_TAB_SWITCHED'; // alert tab switched

export const FLASH_MESSAGE = 'FLASH_MESSAGE'; // show a flash message
export const ALERT_MESSAGE = 'ALERT_MESSAGE'; // show an alert message
export const MAP_ENABLED = 'MAP_ENABLED'; // map enabled for collaborators

// modals
export const MODAL_INTERACTION = 'MODAL_INTERACTION';
export const OPEN_MODAL = 'OPEN_MODAL'; // open react modal
// views
export const SAVE_LAYERS_CLICKED = 'SAVE_LAYERS_CLICKED'; // user clicked save button on Control, to save the current layers as a view
export const VIEW_SAVED = 'VIEW_SAVED'; // user saved a new view
export const VIEW_DELETED = 'VIEW_DELETED'; // user deleted a view
export const VIEW_STATUS = 'VIEW_STATUS'; // cached view status
export const VIEW_RETRYING = 'VIEW_RETRYING'; // user wants to retry loading saved view
export const VIEWS_DATA_LOADED = 'VIEWS_DATA_LOADED'; // data for views tab loaded
export const VIEWS_TAGS_LOADED = 'VIEWS_TAGS_LOADED'; // list of views tags loaded
export const STAR_CLICKED = 'STAR_CLICKED'; // 'favourites' star clicked by user

export const VALIDATED_CUSTOM_COLUMNS = 'VALIDATED_CUSTOM_COLUMNS'; // server has validated (or not) the updated custom columns
export const VALIDATED_EXPRESSION = 'VALIDATED_EXPRESSION'; // server has validated (or not) the column expression
export const EVALUATED_CUSTOM_COLUMNS = 'EVALUATED_CUSTOM_COLUMNS'; // server has evaluated custom columns (i.e. calculated values for them in ColumnsModal)
export const COLUMNS_ROWS_LOADED = 'COLUMNS_ROWS_LOADED'; // server has loaded row data for columns modal
export const COLUMNS_DATA_LOADED = 'COLUMNS_DATA_LOADED'; // server has loaded columns for a query
export const TABLE_COLUMNS_LOADED = 'TABLE_COLUMNS_LOADED'; // server has loaded columns for a given table
export const SQL_CHECKED = 'SQL_CHECKED'; // server has checked user's SQL (in editor)
// modal wrapper
export const MODAL_SAVE_CLICKED = 'MODAL_SAVE_CLICKED'; // user clicked 'save' button on modal
export const MODAL_HIDDEN = 'MODAL_HIDDEN'; // Modal no longer visible
// data table
export const ROW_EXPAND_CLICKED = 'ROW_EXPAND_CLICKED'; // user clicked expand button next to row
export const EXPANDED_ROWS_LOADED = 'EXPANDED_ROWS_LOADED'; // expanded rows came back
// layers
export const LAYER_USER_INTERACTION = 'LAYER_USER_INTERACTION'; // user interacted with a layer
export const AGGREGATE_CONFIGURATION_CHANGED =
  'AGGREGATE_CONFIGURATION_CHANGED'; // user interacted with a layer
// data table
export const DATA_PRESENTATION_CHANGED = 'DATA_PRESENTATION_CHANGED'; // user wants to switch how data is presented

// Map tab
export const MAP_VISIBLE_TABLES_LOADED = 'MAP_VISIBLE_TABLES_LOADED';
export const MAP_VISIBLE_TABLES_UPDATED = 'MAP_VISIBLE_TABLES_UPDATED';
export const MAP_SCALE_UPDATED = 'MAP_SCALE_UPDATED';

// Categories
export const CATEGORY_DELETED = 'CATEGORY_DELETED';

export const RESET_LAYER_IN_EDIT_MODE = 'RESET_LAYER_IN_EDIT_MODE';

export const DEPENDANT_QUERIES_CLICKED = 'DEPENDANT_QUERIES_CLICKED';
export const CUSTOMIZE_AGGREGATE_CLICKED = 'CUSTOMIZE_AGGREGATE_CLICKED';

export const RESET_TABLE_DATA = 'RESET_TABLE_DATA';

export const INCREMENT_SAVED_QUERIES_COUNT = 'INCREMENT_SAVED_QUERIES_COUNT';
